import { render, staticRenderFns } from "./TextModal.vue?vue&type=template&id=d3e661d8&scoped=true&"
import script from "./TextModal.vue?vue&type=script&lang=js&"
export * from "./TextModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3e661d8",
  null
  
)

export default component.exports